import { ApiError, ErrorResponse } from './types';

export function processErrorResponse(res: ErrorResponse): ApiError {
  return res.error;
}
